import {
  createContext,
  useContext,
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import { months } from "@/utils/date-format";
import { GetPayslipUserResult } from "@/models/payslips.model";

interface PayContextType {
  selectedMonth: string;
  selectedYear: string;
  setSelectedMonth: Dispatch<SetStateAction<string>>;
  setSelectedYear: Dispatch<SetStateAction<string>>;
  isProcessListChanged: boolean;
  setIsProcessListChanged: (value: boolean) => void;
  isUnprocessedListChanged: boolean;
  setIsUnprocessedListChanged: (value: boolean) => void;
}

const PayContext = createContext<PayContextType | undefined>(undefined);

export function PayProvider({
  children,
  initialMonth,
  initialYear,
}: {
  children: React.ReactNode;
  initialMonth: string;
  initialYear: string;
}) {
  const [selectedMonth, setSelectedMonth] = useState<string>(initialMonth);
  const [selectedYear, setSelectedYear] = useState<string>(initialYear);
  const [isProcessListChanged, setIsProcessListChanged] = useState(true);
  const [isUnprocessedListChanged, setIsUnprocessedListChanged] =
    useState(true);

  return (
    <PayContext.Provider
      value={{
        selectedMonth,
        selectedYear,
        setSelectedMonth,
        setSelectedYear,
        isProcessListChanged,
        setIsProcessListChanged,
        isUnprocessedListChanged,
        setIsUnprocessedListChanged,
      }}
    >
      {children}
    </PayContext.Provider>
  );
}

export const usePayContext = () => {
  const context = useContext(PayContext);
  if (!context)
    throw new Error("usePayContext must be used within PayProvider");
  return context;
};
